module.exports = __webpack_public_path__ + "materialdesignicons-webfont.b8695cc16b97f1bd9744.eot";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.eot?v=1.8.36
// module id = ../../../../../src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.eot?v=1.8.36
// module chunks = styles